module.exports = __webpack_public_path__ + "img/background-tasting.db1f1c8c.png";